
import Vue from 'vue'
import {
  GET_MODE,
  GET_SHOW_LOGOUT_TIMER_MODE,
  IS_DEBTOR,
  IS_PROFILE_DIALOG_SHOW,
  IS_USER_LOGGED_IN,
  SETTINGS_ALL
} from './store/getter-types'
import AppToolbar from '@/components/AppToolbar.vue'
import AppDrawer from './components/AppDrawer.vue'
import ErrorResponseDialog from '@/components/ErrorResponseDialog.vue'
import {getSetting} from "@/services/settings"
import {SettingsItem} from "@/model/SettingsItem"
import ProfileDialog from '@/components/user/ProfileDialog.vue'
import DebtorWarningBanner from "@/components/DebtorWarningBanner.vue";
import {AUTH_LOG_USER_OUT} from "@/store/action-types";

interface ComponentData {
  forcePinChange: boolean,
  isClickEvent: boolean,
  countDown: number | null,
  timer: any
}

export default Vue.extend({
  name: 'App',

  components: {
    AppToolbar,
    AppDrawer,
    ErrorResponseDialog,
    ProfileDialog,
    DebtorWarningBanner
  },

  data(): ComponentData {
    return {
      forcePinChange: false,
      isClickEvent: false,
      countDown: 30,
      timer: null
    }
  },
  computed: {
    isKioskMode (): boolean {
      return this.$store.getters[GET_MODE] === 'kiosk'
    },

    showLogOutTimer (): boolean {
      return this.$store.getters[GET_SHOW_LOGOUT_TIMER_MODE]
    },

    appSettings(): SettingsItem[] {
      return this.$store.getters[SETTINGS_ALL]
    },

    showAppToolbar(): boolean {
      return this.isUserLoggedIn && (!this.forcePinChange || this.isKioskMode)
    },

    showAppDrawer(): boolean {
      return this.isUserLoggedIn && (!this.forcePinChange || this.isKioskMode)
    },

    isUserLoggedIn(): boolean {
      return this.$store.getters[IS_USER_LOGGED_IN]
    },

    isDebtor(): boolean {
      return this.$store.getters[IS_DEBTOR]
    },

    showDialog (): boolean {
      return this.$store.getters[IS_PROFILE_DIALOG_SHOW]
    }
  },

  methods: {
      resetTimer() {
        if(this.isKioskMode && this.showLogOutTimer) {
          this.isClickEvent = true
          this.countDown = 30
          clearInterval(this.timer)
          this.countDownTimer()
        }
      },

    onOutLoggedUser (){
        if(this.showLogOutTimer) {
          this.logUserOut()
          this.$router.push('/login')
        }

    },

    async logUserOut():Promise<void> {
      await this.$store.dispatch(AUTH_LOG_USER_OUT)
    },

    countDownTimer () {
        if(this.showLogOutTimer) {
          this.timer = setInterval(() => {
            this.countDown! -= 1
            if (this.countDown === 0) {
              clearInterval(this.timer)
              this.onOutLoggedUser()
            }
          }, 1000)
        }
        }
  },


  watch: {
    appSettings(newValue): void {
      this.forcePinChange = getSetting('boarder.force_pin_change')?.value === 'true'
    },

    isUserLoggedIn(newValue): void {
      if(newValue && this.isKioskMode && this.showLogOutTimer) {
        this.resetTimer()
      }
    }
  },

  mounted (): void {
    this.forcePinChange = getSetting('boarder.force_pin_change')?.value === 'true'
  },

  beforeMount () {
    if(this.isKioskMode && this.showLogOutTimer) {
      document.addEventListener('click', this.resetTimer)
      this.resetTimer()
    }
  }
})
